export default "__VITE_ASSET__veIpomlt__"